import React, { Component } from "react";
import MainLayout from "../../components/layouts/main";
import Constants from "../../data/constants";
import DragAndResize from "../../components/DragAndResize";
import ContentScheduler from "../../components/ContentScheduler";
import DirectoryViewComponent from "../../components/views/DirectoryViewComponent";
import { Button, Col, Popover, Modal, Row, Space } from "antd";
import ScreenTableView from "../../components/views/ScreenTableView";
import PrimaryActionButton from "../../components/PrimaryActionButton";
import Data from "../../data/data";
import WeekdayScheduler from "../../components/WeekdayScheduler";
import { connect } from "react-redux";
import {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
} from "../../actions";
import TimelineListElement from "../../components/TimelineListElement";
import PopupManager from "../../managers/PopupManager";
import { Container, Draggable } from "react-smooth-dnd";
import { applyDrag } from "../../utils/DragUtils";
import { CloudUploadOutlined, PlayCircleOutlined } from "@ant-design/icons";
import CalendarView from "../../components/views/CalendarView";
import PermissionManager from "../../managers/PermissionManager";
import ScreenPreviewPopup from "../../components/popups/ScreenPreviewPopup";
import WidgetInstanceItem from "../../components/WidgetInstanceItem";
import {
  preparePlaylists,
  prepareTimelineElements,
} from "../../helpers/ContentJsonHelper";
import CreateWidgetInstancePage from "../../components/popups/CreateWidgetInstancePage";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

// import
class WidgetInstanceListPage extends Component {
  constructor(props) {
    super(props);
    this.screenPreviewPopupRef = React.createRef();
    this.state = {
      widgetInstanceDatas: [],
      viewMode: "timeline",
      createPopupVisible: false,
      selectedWidgetInstanceData: undefined,
    };
  }

  componentDidMount() {
    this.updateWidgetInstanceListData();
  }

  updateWidgetInstanceListData = () => {
    const { requestServerGet, userdata, selectedBrandData, selectedWidget } =
      this.props;

    // if (!selectedBrandData)
    //     return;

    if (!selectedWidget) return;

    var optionalParams = {};

    if (selectedBrandData)
      optionalParams = { brandid: selectedBrandData.BrandID };
    // const colors = ["#A70267", "#F10C49", "#FB6B41", "#F6D86B", "#339194"]
    // const colors = ["#fc5c65", "#fd9644", "#fed330", "#2bcbba", "#45aaf2", "#4b7bec", "#a55eea", "#d1d8e0", "#778ca3", "#eb3b5a", "#fa8231", "#f7b731", "#20bf6b", "#0fb9b1", "#2d98da", "#3867d6", "#8854d0", "#a5b1c2", "#4b6584"]
    const colors = [
      "#C78283",
      "#26547C",
      "#32936F",
      "#FFE066",
      "#0E6BA8",
      "#60D394",
      "#F3722C",
      "#0EAD69",
      "#277DA1",
      "#F94144",
    ];
    // const colors = ["#45aaf2", "#4b7bec", "#a55eea", "#d1d8e0", "#778ca3", "#2d98da", "#3867d6", "#8854d0", "#a5b1c2", "#4b6584"]
    requestServerGet(
      "get_widget_instances",
      { ...optionalParams, widgetid: selectedWidget.WidgetID },
      null,
      (response) => {
        console.log(JSON.stringify(response.data));
        this.setState({
          widgetInstanceDatas: response.data,
        });
      },
      userdata.token,
    );
  };

  onEditTimelineClicked = (timelineID) => {
    const timelineData = this.state.widgetInstanceDatas.find((tl) => {
      return tl.TimelineID === timelineID;
    });

    if (timelineData) this.launchEditTimeline(timelineData);
  };

  onDelteTimelineClicked = (timelineID) => {
    const { requestServerPost, userdata } = this.props;

    requestServerPost(
      "delete_timeline",
      { timelineid: timelineID },
      null,
      (response) => {
        // console.log(JSON.stringify(response.data))
        this.updateWidgetInstanceListData();
      },
      userdata.token,
    );
  };

  renderWidgetInstanceItem = (data, index) => {
    console.log("renderWidgetInstanceItem");
    const editPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_CAMPAIGN,
      PermissionManager.PERMISSION_TYPE_EDIT,
    );

    // return <TimelineListElement onTimelineUpdated={this.updateTimelineListData} allowEdit={editPermission} allowDelete={editPermission} onClick={() => {
    //     this.onTimelnieSelected(data);
    // }} onEdit={this.onEditTimelineClicked} onDelete={this.onDelteTimelineClicked} data={data} index={index}></TimelineListElement>
    return (
      <WidgetInstanceItem
        onClick={() => {
          this.setState({
            selectedWidgetInstanceData: data,
            createPopupVisible: true,
          });
        }}
        onEdit={() => {
          this.setState({
            selectedWidgetInstanceData: data,
            createPopupVisible: true,
          });
        }}
        onDelete={() => this.deleteWidgetInstance(data)}
        data={data}
      ></WidgetInstanceItem>
    );
    // return <div style={{ width: "200px", height: "100px", backgroundColor: "red" }}>{JSON.stringify(data.WidgetInstanceName)}</div>
    // return <div style={{ width: "100%", height: "100px", backgroundColor: "red", borderRadius: "4px" }}>{data.WidgetInstanceName}</div>
  };

  // tryDelete = (data) => {
  //     Modal.confirm(
  //         {
  //             title: 'Warning',
  //             icon: <ExclamationCircleOutlined />,
  //             content: `Do you want to delete the instance ${data.WidgetInstanceName}?`,
  //             okText: 'OK',
  //             cancelText: 'Cancel',
  //             onOk: () => { this.delete(data) }
  //         }
  //     )
  // }

  deleteWidgetInstance = (data) => {
    const { requestServerPost, userdata } = this.props;

    requestServerPost(
      "delete_widget_instance",
      { widgetinstanceid: data.WidgetInstanceID },
      null,
      (response) => {
        Modal.success({
          content: `Successfully deleted ${data.WidgetInstanceName}`,
        });
        this.updateWidgetInstanceListData();
      },
      userdata.token,
    );
  };

  renderTimelineList = () => {
    console.log("renderTimelineList");
    if (this.state.widgetInstanceDatas.length === 0) return null;

    const { selectedBrandData, globalSearch = "aloha" } = this.props;

    return this.state.widgetInstanceDatas
      .filter((data) => {
        return globalSearch
          ? data.TimelineName.toLocaleLowerCase().includes(
              globalSearch.toLocaleLowerCase(),
            )
          : true;
      })
      .map((data, index) => {
        return (
          <Draggable key={data.WidgetInstanceID}>
            {/* <Col span={24}> */}
            {/* <motion.div style={{ width: "100%", display: "block" }} animate={{ scale: 0.96 }} whileHover={{ scale: 1, transition: { duration: 0.1 } }}> */}
            {/* <div style={{ width: "100%", display: "block" }}> */}
            <div className="draggable-item">
              {this.renderWidgetInstanceItem(data, index)}
              {/* </div> */}
              {/* </Col > */}
            </div>
          </Draggable>
        );
      });
  };

  launchAssignAndPublish = (campaignData) => {
    const { selectedWidget } = this.props;
    PopupManager.launchAssignAndPublishPopup(campaignData);
  };
  launchCreateWidgetInstance = () => {
    const { selectedWidget } = this.props;
    this.setState({
      createPopupVisible: true,
      selectedWidgetInstanceData: undefined,
    });
    // PopupManager.launchCreateWidgetInstancePopup(selectedWidget, this.updateWidgetInstanceListData)
  };

  launchEditTimeline = (timelineData) => {
    const { selectedWidget } = this.props;
    PopupManager.launchEditTimelinePopup(
      timelineData,
      selectedWidget,
      this.updateWidgetInstanceListData,
    );
  };

  onTimelineItemReordered = (dragResult) => {
    const { requestServerPost, userdata, selectedWidget } = this.props;

    // console.log("onTimelineItemReordered " + JSON.stringify(dragResult))

    const newArray = applyDrag(this.state.widgetInstanceDatas, dragResult);
    const orderings = newArray
      .map((tl) => {
        return tl.TimelineID;
      })
      .reduce((v1, v2) => `${v1},${v2}`);

    requestServerPost(
      "update_ordering",
      {
        target: "timelines",
        values: orderings,
        parentid: selectedWidget.CampaignID,
      },
      null,
      (response) => {
        this.updateWidgetInstanceListData();
      },
      userdata.token,
    );

    this.setState({ widgetInstanceDatas: newArray });
  };

  onViewModeChange = (e) => {
    this.setState({ viewMode: e.target.value });
  };

  renderCampaignContent = () => {
    return this.renderTimelineList();
  };

  render() {
    const createPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_WIDGET,
      PermissionManager.PERMISSION_TYPE_CREATE,
    );
    const t = this.props.langT || PRO_TRANSLATIONS.en.widgetInstancePage;
    const tw = this.props.langTWidget || PRO_TRANSLATIONS.en.widgetPage;

    const {
      onBackClicked = () => {},
      preventDefaultStepBack = false,
      selectedWidget,
      localStepBack = () => {},
      selectedBrandData,
    } = this.props;

    const publishTitles = [];

    const publishTitleString = publishTitles.join(" / ");

    console.log(
      "selectedWidgetInstanceData " + this.state.selectedWidgetInstanceData,
    );
    return (
      // <div style={{ width: "1000px", height: "1000px" }}>
      /* <ContentScheduler></ContentScheduler> */
      /* <DirectoryViewComponent></DirectoryViewComponent> */
      /* </div> */

      // <MainLayout id={Constants.TIMELINE_PAGE}>
      //     <WeekdayScheduler></WeekdayScheduler>
      //     {/* <Button style={{ float: "right", zIndex: 20, marginBottom: "16px" }} type=   "primary" onClick={this.launchCreateScreen}>Create Screen</Button>
      //     <ScreenTableView data={Data.MOCK_BRANCHES} onRowClicked={this.onCampaignContentClicked}></ScreenTableView> */}
      // </MainLayout>
      <>
        <MainLayout
          renderBreadCrumb={() => {
            return [
              <span
                onClick={() => { localStepBack("Widget"); }}
                style={{ fontSize: 14, fontWeight: 600, color: "#64748b", padding: "4px 8px", lineHeight: "22px", cursor: "pointer" }}
              >
                {tw.pageTitle}
              </span>,
              selectedWidget
                ? [
                    "/",
                    <span
                      onClick={() => {
                        this.setState({
                          selectedWidgetInstanceData: null,
                          createPopupVisible: false,
                        });
                      }}
                      style={{ fontSize: 14, fontWeight: 600, color: "#64748b", padding: "4px 8px", lineHeight: "22px", cursor: "pointer" }}
                    >
                      {selectedWidget.WidgetName}
                    </span>,
                  ]
                : null,
              this.state.selectedWidgetInstanceData
                ? [
                    "/",
                    <span
                      style={{ fontSize: 14, fontWeight: 500, color: "#94a3b8", padding: "4px 8px", lineHeight: "22px" }}
                    >
                      {this.state.selectedWidgetInstanceData.WidgetInstanceName}
                    </span>,
                  ]
                : null,
            ];
          }}
          onBackClicked={() => {
            if (this.state.createPopupVisible) {
              Modal.confirm({
                title: t.discardWarningTitle,
                icon: <ExclamationCircleOutlined />,
                content: t.discardWarningContent,
                okText: t.ok,
                cancelText: t.cancel,
                onOk: () => {
                  this.setState({ createPopupVisible: false });
                },
              });
            } else onBackClicked();
          }}
          preventDefaultStepBack={preventDefaultStepBack}
          id={Constants.WIDGET_PAGE}
        >
          <Row
            justify="space-between"
            style={{ float: "right", padding: "0 40px" }}
          >
            <Col>
              {createPermission ? (
                <Space style={{ float: "right", zIndex: 20 }}>
                  <PrimaryActionButton
                    style={{ float: "right", zIndex: 20 }}
                    onClick={this.launchCreateWidgetInstance}
                  >
                    {t.createInstance}
                  </PrimaryActionButton>
                  {/* <Popover content={<div>Test</div>} trigger="click"> */}

                  {/* </Popover> */}
                </Space>
              ) : null}
            </Col>
          </Row>

          <div
            className="site-layout-background"
            style={{
              margin: 0,
              minHeight: 280,
              backgroundColor: "transparent",
            }}
          >
            {/* <motion.div initial="initial" animate="animate" whileTap="tap" variants={Animations.STAGGER} style={{ display: "inline-block", maxWidth: "1200px", textAlign: "center" }}> */}

            {/* <Row gutter={[8, 8]} justify="space-around" align="middle" className="site-layout-background"
                        style={{

                        }}> */}
            <Container
              dragHandleSelector=".column-drag-handle"
              onDrop={this.onTimelineItemReordered}
            >
              {this.renderCampaignContent()}
            </Container>
            {/* </Row> */}
          </div>
          <ScreenPreviewPopup
            key="screen_preview"
            ref={this.screenPreviewPopupRef}
          ></ScreenPreviewPopup>

          {this.state.createPopupVisible && (
            <div
              style={{
                flex: 1,
                padding: "0px",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                top: "50px",
                bottom: 0,
                zIndex: 500,
                backgroundColor: "#00000055",
              }}
            >
              {/* <div style={{ height: "100%", backgroundColor: "white", flex: 1, zIndex: 5000 }}> */}
              <div
                style={{
                  height: "100%",
                  backgroundColor: "white",
                  flex: 1,
                  zIndex: 5000,
                  borderRadius: "0px",
                  overflow: "hidden",
                }}
              >
                <CreateWidgetInstancePage
                  onComplete={() => {
                    this.setState({ createPopupVisible: false });
                    this.updateWidgetInstanceListData();
                  }}
                  onClose={() => {
                    this.setState({ createPopupVisible: false });
                  }}
                  widgetData={selectedWidget}
                  widgetInstanceData={this.state.selectedWidgetInstanceData}
                  brandID={
                    selectedBrandData ? selectedBrandData.BrandID : undefined
                  }
                ></CreateWidgetInstancePage>
              </div>
            </div>
          )}
        </MainLayout>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    globalSearch: state.globalSearch,
    selectedBrandData: state.selectedBrandData,
  };
};

const ConnectedWidgetInstanceListPage = connect(mapStateToProps, {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
})(WidgetInstanceListPage);

const WidgetInstanceListPageWithLang = (props) => {
  const { lang } = useProLanguage();
  const t =
    PRO_TRANSLATIONS[lang]?.widgetInstancePage ||
    PRO_TRANSLATIONS.en.widgetInstancePage;
  const tw =
    PRO_TRANSLATIONS[lang]?.widgetPage || PRO_TRANSLATIONS.en.widgetPage;
  return (
    <ConnectedWidgetInstanceListPage langT={t} langTWidget={tw} {...props} />
  );
};

export default WidgetInstanceListPageWithLang;
